/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMBED : ANSWER SET : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	answerset: {
		width: '100%',
		height: '70%',
		paddingTop: pxToEm(10),

		// ..... TEXT 1 ..... //
	// 	'&.text1': {
	// 		fontSize: '85%',
	// 		// display: 'flex',
	// 		// flexDirection: 'column',
	// 		// justifyContent: 'center',
	// 		'&.answeramount-2': {
   //              fontSize: '90%',
   //          }
   //      },
   //
   //      // ..... TEXT 2 ..... //
   //      '&.text2': {
	// 		fontSize: '85%',
   // //      	display: 'flex',
	// 		// flexDirection: 'column',
	// 		// justifyContent: 'center',
	// 		'&.answeramount-2': {
   //              fontSize: '90%'
   //          }
   //      },

        // ..... IMAGE 1 ..... //
		'&.image1': {
			display: 'flex',
			flexWrap: 'nowrap',
			alignItems: 'center',
			justifyContent: 'space-around',
			'&.answeramount-2': {
                fontSize: '120%',
                '& .answer': { width: '46%' },
                '& .answer .graphic': { fontSize: '110%' }
            },
            '&.answeramount-4': {
                fontSize: '85%',
                '& .answer': {},
                '& .answer .graphic': { fontSize: '85%' }
            }
		},

		// ..... IMAGE 2 ..... //
		'&.image2': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-around',
			'& .answer': {
				height: '100%',
				marginRight: pxToEm(7),
				'&:last-child': { marginRight: '0' }
			},
			'&.answeramount-2': {
	            '& .answer': { 
	                width: '49%'
	            }
	        },
	        '&.answeramount-3': {
	            '& .answer': { 
	                width: '32%'
	            }
	        },
	        '&.answeramount-4': {
	            fontSize: '85%',
	            '& .answer': { 
	                width: '25%'
	            }
	        }
	    },

	    // ..... EMOJI ..... //
	    '&.emoji': {
	    	display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-around',
	    	'&.answeramount-2': {
                fontSize: '120%',
                '& .answer': { width: '46%' },
                '& .answer .graphic': { fontSize: '110%' }
            },
            '&.answeramount-4': {
                fontSize: '85%',
                '& .answer': { width: '23%' },
                '& .answer .graphic': { fontSize: '90%' }
            }
        }
	}
});